import React, { useCallback, useState } from 'react';
import {
  Area,
  Avatar,
  Box,
  IconButton,
  Icons,
  Text,
  Tooltip,
  useTheme,
} from '@ublend-npm/aulaui-core';
import getSubCategories from '@core/spaceSelector/utils/getSubCategories';
import push from '../../../../../utils/routing';
import { OverlayContainer, StarSpace } from './Helpers';

const CardView = (space: any) => {
  const { palette } = useTheme();
  const {
    name = '',
    archived,
    isStarred,
    spaceId,
    avatar = '',
    hasActivity,
    isAssigned,
    // isEducator,
    isStaff,
    categories,
    onSpaceStar,
    onfetchRecentlyViewedSpaces,
  } = space;
  let category: { label: string };
  let subCategory: any[];
  const [isStarSaving, setIsStarSaving] = useState(false);

  const onClickCardView = () => {
    push(`/dashboard/${spaceId}/myspacenav`);
  };

  if (categories && categories?.length) {
    category = categories?.at(0) || {};
    subCategory = getSubCategories([space], category?.label);
  }

  const handleStartUnstartSpace = async (e: React.MouseEvent) => {
    try {
      e.preventDefault();
      e.stopPropagation();
      const subCategoryLabel = subCategory[0]?.label || '';
      const categoryLabel = category?.label || '';
      setIsStarSaving(true);
      const payload: StarSpace = {
        spaceId,
        showArchived: archived,
        sort: 'az',
        search: '',
        category: categoryLabel,
        subCategory: subCategoryLabel,
      };

      await onSpaceStar(payload);
      await onfetchRecentlyViewedSpaces();
      setTimeout(() => setIsStarSaving(false), 1000);
    } catch (error) {
      console.error('Error in handleStartUnstartSpace:', error);
    }
  };

  const onKeyPressEnter = async (event) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      onClickCardView();
    }
  };

  const StaredUnstared = useCallback(() => {
    return (
      <IconButton
        tabIndex={0}
        aria-label={`${isStarred ? 'Unstar' : 'Star'} the ${name} space`}
        onClick={handleStartUnstartSpace}
        size="small"
        disabled={isStarSaving}
        color="primary"
        sx={{
          '&:active': { transform: 'scale(0.9)' }, // Add a slight press effect
          padding: '8px',
        }}
      >
        {isStarSaving || isStarred ? <Icons.Star /> : <Icons.StarBorder />}
      </IconButton>
    );
  }, [isStarred, isStarSaving]);

  return (
    <Box
      key={spaceId}
      tabIndex={0}
      role="list"
      aria-label={`Switch to the ${name}`}
      sx={{
        position: 'relative',
        '&:hover .overlay': {
          display: 'flex',
        },
      }}
      onKeyPress={onKeyPressEnter}
    >
      <Tooltip position="bottom" title={name?.length > 17 ? name : null}>
        <Area
          display="flex"
          flexDirection="column"
          justifyContent="space-between"
          gap="1rem"
          sx={{
            height: '8.75rem',
            width: '12.5rem',
            borderRadius: '0.5rem',
            cursor: 'pointer',
          }}
          onClick={onClickCardView}
        >
          <Box display="flex" justifyContent="space-between" gap="0.5rem">
            <Avatar
              kind="circular"
              src={avatar}
              fallbackText={name?.charAt(0).toUpperCase()}
              showBadge={hasActivity}
              badgeColor={palette.primary.main}
              sx={{
                bgcolor: '#5d536c',
                color: '#fff',
                cursor: 'pointer',
              }}
            />

            {typeof isStarred === 'boolean' && <StaredUnstared />}
          </Box>

          <Box
            display="flex"
            justifyContent="end"
            flexDirection="column"
            sx={{ cursor: 'pointer' }}
            tabIndex={0}
          >
            <Text fontWeight="500" maxLines={archived ? 1 : 2}>
              {name}
            </Text>

            {archived && (
              <Text
                fontSize="0.85rem"
                color="text.secondary"
                mt={0.25}
                tabIndex={0}
              >
                Archived
              </Text>
            )}
          </Box>
        </Area>
      </Tooltip>
      {!isStaff && (
        <OverlayContainer palette={palette} isAssigned={isAssigned} />
      )}
    </Box>
  );
};

export default CardView;
